"use client";
import { useContext } from "react";
import { RecentLeaderContext } from "@/components/server/RecentLeaderBoardContainer/context";
import "./recent.scss";
import React from ".";
import TeamSection from "./TeamSection";
import MatchHistoryTable from "./MatchHistoryTable";

const RecentTable = (props) => {
  const {
    home,
    away,
    homeMatches: homeMatchesData,
    awayMatches: awayMatchesData,
    homeHalftimeChecked,
    awayHalftimeChecked,
    homeTotal,
    awayTotal,
  } = useContext(RecentLeaderContext);

  const {
    matches: homeMatches,
    winLossRate: homeWinLossRate,
    halfTimeWinLossRate: homeHalfTimeWinLossRate,
    handicapRate: homeHandicapRate,
    overUnderRate: homeOverUnderRate,
  } = homeMatchesData;
  const {
    matches: awayMatches,
    winLossRate: awayWinLossRate,
    halfTimeWinLossRate: awayHalfTimeWinLossRate,
    handicapRate: awayHandicapRate,
    overUnderRate: awayOverUnderRate,
  } = awayMatchesData;

  return (
    <>
      {/*home*/}
      <div className={"my-2 p-4  bg-white dark:bg-dark-slate"}>
        {/*home*/}
        <TeamSection
          isHome={true}
          team={home}
          total={homeTotal}
          winLossRate={
            homeHalftimeChecked ? homeHalfTimeWinLossRate : homeWinLossRate
          }
          totalRate={homeMatches.length}
          handicapRate={homeHandicapRate}
          overUnderRate={homeOverUnderRate}
        />
        <MatchHistoryTable
          matches={homeMatches}
          isHalftimeChecked={homeHalftimeChecked}
        />
      </div>

      {/*away*/}
      <div className={"my-2 p-4 bg-white dark:bg-dark-slate"}>
        <TeamSection
          isHome={false}
          team={away}
          total={awayTotal}
          totalRate={awayMatches.length}
          winLossRate={
            awayHalftimeChecked ? awayHalfTimeWinLossRate : awayWinLossRate
          }
          handicapRate={awayHandicapRate}
          overUnderRate={awayOverUnderRate}
        />
        <MatchHistoryTable
          matches={awayMatches}
          isHalftimeChecked={awayHalftimeChecked}
        />
      </div>
    </>
  );
};

export default RecentTable;
